import React, { useMemo } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import ClientTable from '@/components/tables/ClientTable';
import { useSelector } from 'react-redux';
import { PageHeader } from '@/components/layouts/PageHeader';
import HomepageDashboard from '@/components/layouts/HomepageDashboard';
import { TeamViewToggle } from '@/components/buttons/TeamViewToggle';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/app/routes';
import { useDispatch } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { VIEW_TYPES } from '@/features/config/helper';
import PreviewDrawer from '@/components/Drawers/PreviewDrawer';

export const ClientsView = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const account = useSelector((state) => state.msalAccount.account);
	const name = useMemo(() => account?.name.split(' ')[0], [account]);

	const { getFeatureFlags } = useFeatureFlagContext();
	const useNewCreateClientForm = Boolean(getFeatureFlags('createNewClient')?.active);

	const handleNewClient = () => {
		if (useNewCreateClientForm) {
			dispatch(openDialog('clientDialog'));
		} else {
			navigate(paths.createNewBusiness, {
				state: { isProspect: false, type: VIEW_TYPES.create },
			});
		}
	};

	const headerElement = (
		<>
			<TeamViewToggle />
			<Button variant='contained' startIcon={<Add />} onClick={handleNewClient}>
				New Client
			</Button>
		</>
	);

	return (
		<Box
			id='clients-view'
			sx={{
				pt: 1,
				pb: 3,
			}}
		>
			<PageHeader title={`Kia ora ${name}`} headerElement={headerElement} />

			<Box px={3}>
				<HomepageDashboard />

				<Typography variant='h5' sx={{ fontWeight: 'bold', mt: 4, mb: 1 }}>
					Clients
				</Typography>

				<ClientTable />
			</Box>

			<PreviewDrawer />
		</Box>
	);
};
